import { Link } from "react-router-dom";
import { categories } from "@/mocks/sportsData";

export default function CategoryNav() {
  return (
    <section className="w-full px-4 md:px-6 py-12 md:py-16 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-8">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            赛事分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            覆盖全球主流体育项目，满足你的每一种热爱
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-4 lg:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-3 p-5 bg-background-50 rounded-2xl border border-background-200/70 hover:border-primary-200 hover:bg-primary-50/50 transition-all cursor-pointer group"
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-xl`}></i>
              </div>
              <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {cat.name}
              </span>
              <span className="text-xs text-foreground-400">{cat.count} 篇</span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}